import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import styled from "styled-components";
import {
  MenuDotIcon,
  ExportIcon,
  PersonIcon,
  SearchIcon,
  PencilIcon,
  ArrowIcon,
  TailArrowIcon,
  TimerIcon,
  MenuIcon,
  ChatIcon,
  ModeIcon,
  OpacityIcon,
  CrossIcon,
  TipIcon,
} from "../../icon/Icons";

import tip from "../../images/tipImg.png";

import WGLogo from "../../images/WGLogo.png";
import { userColors } from "../../util/colors";
import CommonUserIcon from "../../common/CommonUserIcon";
import CommonCellButton from "../../common/CommonCellButton";
import { useDispatch, useSelector } from "react-redux";
import menuImg from "../../images/메뉴2.png";
import CellContent from "./CellContent";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { commonAction } from "../../slices/GameSlice";
import CommonAlertModal from "../../common/CommonAlertModal";

const tabItems = [
  { label: "파일" },
  { label: "홈" },
  { label: "삽입" },
  { label: "공유" },
  { label: "페이지 레이아웃" },
  { label: "수식" },
  { label: "데이터" },
  { label: "검토" },
  { label: "보기" },
  { label: "자동화" },
  { label: "도움말" },
  { label: "그리기" },
];

const ContentWrap = () => {
  const { roomId, gameMode, users, workMode, alertDisplay, opacityOn } =
    useSelector((state) => state.GameSlice);
  const [inputDisplay, setInputDisplay] = useState(false);
  const [tipDisplay, setTipDisplay] = useState(false);
  const roomRef = useRef();

  const dispatch = useDispatch();
  const navigator = useNavigate();
  const gameList = [
    { label: "Sheet1", value: "다빈치코드" },
    { label: "Sheet2", value: "오목" },
    { label: "Sheet3", value: "할리갈리" },
    { label: "Sheet4", value: "훈민정음" },
    // { label: "Sheet5", value: "페이크카드" },
  ];
  const inputHandler = () => {
    if (!roomId) {
      setInputDisplay(true);
      setTimeout(() => {
        roomRef.current.focus();
      }, 0);
    }
  };

  const EnterHandler = () => {
    navigator(`project/${roomRef.current.value}`);
    setInputDisplay(false);
  };

  return (
    <BodyWrap>
      {tipDisplay && (
        <TipItem>
          <img width={1920} height={911} src={tip} alt="tip" />
          <TipCloseItem
            onClick={() => {
              setTipDisplay(false);
            }}
          >
            <CrossIcon fill={"#fff"} />
          </TipCloseItem>
        </TipItem>
      )}
      <PageWrap>
        {alertDisplay && <CommonAlertModal title={"입장"} />}
        <TopWrap>
          <HeaderWrap>
            <TitleItem>
              <MenuDotIcon />
              <LogoImage src={WGLogo} alt="logo" />
              <span>WG 프로젝트</span>
            </TitleItem>
            <CenterDiv onClick={inputHandler}>
              <ClickInput
                style={{ cursor: (roomId || inputDisplay) && "default" }}
              >
                <SearchIcon />

                {!inputDisplay ? (
                  <>
                    <span>
                      {workMode
                        ? "도구, 도움말 등을 검색(ALT + Q)."
                        : roomId
                        ? roomId
                        : "입장하기"}
                    </span>
                  </>
                ) : (
                  <>
                    <EnterInput
                      ref={roomRef}
                      defaultValue=""
                      onBlur={() => setInputDisplay(false)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          EnterHandler();
                        }
                      }}
                    />
                    <span
                      style={{ height: "20px", cursor: "pointer" }}
                      onMouseDown={EnterHandler}
                    >
                      <TailArrowIcon />
                    </span>
                  </>
                )}
              </ClickInput>
            </CenterDiv>
            <HeaderIcons>
              <HeaderIcon
                onClick={() => {
                  setTipDisplay(true);
                }}
              >
                <TipIcon />
              </HeaderIcon>
              <HeaderIcon
                onClick={() => {
                  dispatch(commonAction({ target: "roomId", value: "" }));
                  dispatch(commonAction({ target: "users", value: [] }));

                  navigator("/");
                }}
              >
                <ExportIcon />
              </HeaderIcon>
              <HeaderIcon>
                <PersonIcon />
              </HeaderIcon>
            </HeaderIcons>
          </HeaderWrap>
          <HeaderWrap style={{ marginTop: "13px" }}>
            <TabRows>
              {tabItems.map((item) => (
                <span key={`${item.label}tabKey`}>{item.label}</span>
              ))}
            </TabRows>
            <RightContainer>
              <UserContainer>
                {users.map((item, index) => (
                  <CommonUserIcon
                    key={`${index}UserIconKey`}
                    color={userColors[item.order]}
                    focus={1}
                  />
                ))}
              </UserContainer>
              <RightButtonContainer>
                <CommonCellButton hoverBlock styles={{ padding: "0 6px" }}>
                  <ChatIcon />
                  <span style={{ width: "62px", textAlign: "center" }}>
                    메모
                  </span>
                </CommonCellButton>
                <CommonCellButton hoverBlock styles={{ padding: "0 6px" }}>
                  <PencilIcon />
                  <span style={{ width: "62px", textAlign: "center" }}>
                    편집중
                  </span>
                </CommonCellButton>
                <CommonCellButton hoverBlock styles={{ padding: "0 6px" }}>
                  <ExportIcon />
                  <span style={{ width: "62px", textAlign: "center" }}>
                    공유
                  </span>
                </CommonCellButton>
              </RightButtonContainer>
            </RightContainer>
          </HeaderWrap>
          <ToolArea>
            <img src={menuImg} alt="menu" />
            <MessageBox></MessageBox>
          </ToolArea>
          <RightButtonContainer style={{ marginTop: "4px" }}>
            <CommonCellButton styles={{ backgroundColor: "#fff" }}>
              <TimerIcon />
              <span style={{ width: "62px", textAlign: "center" }}>
                {workMode ? "" : "타이머"}
              </span>
            </CommonCellButton>
            <span
              onClick={() =>
                dispatch(commonAction({ target: "workMode", value: !workMode }))
              }
            >
              <CommonCellButton
                styles={{ backgroundColor: "#fff", alignItems: "center" }}
              >
                <ModeIcon />
                <span
                  style={{
                    width: "62px",
                    textAlign: "center",
                  }}
                >
                  {workMode ? "" : "WG"}
                </span>
              </CommonCellButton>
            </span>
            <span
              onClick={() =>
                dispatch(
                  commonAction({ target: "opacityOn", value: !opacityOn })
                )
              }
            >
              <CommonCellButton
                styles={{ backgroundColor: "#fff", alignItems: "center" }}
              >
                <OpacityIcon />
                <span
                  style={{
                    width: "62px",
                    textAlign: "center",
                  }}
                >
                  {workMode ? "" : "투명도"}
                </span>
              </CommonCellButton>
            </span>

            <LongTextArea></LongTextArea>
          </RightButtonContainer>
        </TopWrap>
        <CellContent />
        <GameBar>
          <ArrowIcon />
          <span style={{ rotate: "180deg", height: "20px" }}>
            <ArrowIcon />
          </span>
          <MenuIcon />
          {roomId &&
            gameList.map((item, index) => (
              <GameTag
                key={`${index}gameModeButton`}
                $select={gameMode === item.value}
                onClick={() => {
                  const docRef = doc(db, "game", `room${roomId}`);
                  updateDoc(docRef, {
                    gameMode: item.value,
                  });
                }}
              >
                <span>{item.label}</span>
                <span>{item.value}</span>
                <GameTagBottomLine $select={gameMode === item.value} />
              </GameTag>
            ))}
        </GameBar>
        <BottomBar>통합 문서 통계</BottomBar>
      </PageWrap>
    </BodyWrap>
  );
};

export default ContentWrap;

const BodyWrap = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  justify-content: start;
  align-items: start;
  background-color: #f0f0f0;
  overflow-y: auto;
`;
const TopWrap = styled.div`
  width: 100%;
  display: flex;
  padding: 0 8px;
  flex-direction: column;
`;

const PageWrap = styled.div`
  width: 1920px;
  height: 911px;
  position: relative;
`;
const TipItem = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 5;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.8);
`;
const TipCloseItem = styled.div`
  width: 40px;
  height: 40px;
  position: absolute;
  cursor: pointer;
  top: 4px;
  left: 1724px;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  &:hover {
    opacity: 0.8;
  }
`;

const LogoImage = styled.img`
  width: 17px;
  height: 18px;
`;

const HeaderWrap = styled.div`
  width: 100%;
  padding-left: 8px;
  display: flex;
  justify-content: space-between;
  position: relative;
`;

const TitleItem = styled.div`
  display: flex;
  gap: 15px;
  font-size: 12px;
  align-items: center;
  svg {
    cursor: pointer;
  }
`;
const HeaderIcons = styled.div`
  display: flex;
  svg {
    cursor: pointer;
  }
`;
const HeaderIcon = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;

  &:hover {
    background-color: #ebebeb;
  }
`;

const CenterDiv = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  translate: -50% calc(-50% + 8px);
`;

const ClickInput = styled.div`
  width: 470px;
  height: 34px;
  padding: 0 18px;
  display: flex;
  align-items: center;
  gap: 10px;

  color: #7f7f7f;
  border-radius: 6px;
  background-color: #f9f9f9;
  border: 1px solid #dcdcdc;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;

const RightContainer = styled.div`
  display: flex;
  gap: 12px;
`;
const UserContainer = styled.div`
  display: flex;
  gap: 12px;
`;
const RightButtonContainer = styled.div`
  display: flex;
  gap: 8px;
`;

const TabRows = styled.div`
  display: flex;
  gap: 22px;
  color: #424242;
  font-size: 14px;
`;

const BottomBar = styled.div`
  width: 1920px;
  height: 22px;
  background-color: #fff;
  color: #616161;
  display: flex;
  padding: 4px 20px;
  font-size: 12px;
  position: fixed;
  bottom: 0;
  left: 0;
`;

const ToolArea = styled.div`
  width: 100%;
  gap: 6px;
  display: flex;
  margin-top: 6px;
  flex-wrap: nowrap;
  img {
    width: 1542px;
    height: 100px;
  }
`;

const MessageBox = styled.div`
  display: flex;
  flex-direction: column-reverse;
  width: 356px;
  height: 100px;
  border-radius: 10px;
  background-color: #fff;
  padding: 10px 10px 0;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const LongTextArea = styled.div`
  flex-grow: 1;
  height: 24px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  border: 1px solid #d1d1d1;
  border-radius: 6px;
  background-color: #fff;
  font-size: 12px;
  box-sizing: border-box;
`;

const GameBar = styled.div`
  width: 100%;
  height: 32px;
  padding-top: 5px;
  padding-left: 5px;
  display: flex;
  gap: 10px;
`;

const EnterInput = styled.input`
  flex-grow: 1;
  color: #616161;
  border: none;
  outline: none;
  background-color: #f9f9f9;
  &:focus {
    outline: none;
  }
`;

const GameTag = styled.div`
  display: flex;
  width: 60px;
  flex-direction: column;
  align-items: center;
  white-space: nowrap;
  font-size: 14px;
  color: ${({ $select }) => ($select ? "#242424" : "#424242")};
  font-weight: ${({ $select }) => ($select ? "700" : "400")};
  gap: 6px;

  cursor: pointer;
  :nth-child(2) {
    display: none;
  }

  &:hover {
    :nth-child(1) {
      display: none;
    }
    :nth-child(2) {
      display: block;
    }
    opacity: 0.8;
  }
`;
const GameTagBottomLine = styled.div`
  width: 100%;
  min-height: 3px;
  background-color: ${({ $select }) => ($select ? "#107C41" : "none")};
`;
